import moment from 'moment';

// Returns '' for a missing or unparseable date, never "Invalid date".
export const getFormattedDateString = (dateString, format) => {
  if (dateString === null || dateString === undefined || dateString === '') return '';
  const date = moment(new Date(dateString));
  return date.isValid() ? date.format(format) : '';
};
